export const rejectedHeartRunnerListState = {
    isLoading: false,
    rejectedHeartRunnerList: [],
    errorCode : 0,
    statusCode : 0,
    message : '',
    regionList:[],
}